module.exports = __webpack_public_path__ + "static/psych-book-2d65454770871bfd00bbd82b36331e44.jpg";